import { AfterViewInit, Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, map } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { SharedService } from './services/sharedService';
import { hasStoredSession } from './util/session.util';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppComponent implements AfterViewInit {
  @ViewChild('mainContent') mainContent: ElementRef;

  isLoggedIn = false;
  title = 'RDFusion';
  activeUser = true;
  isControlModule = false;
  isFullWidth = false;

  constructor(public translate: TranslateService, private router: Router, public auth: AuthService,
              private userService: UserService, private activatedRoute: ActivatedRoute,
              private sharedService: SharedService) {
    translate.setFallbackLang('en');
  }
  username;

  /**
   * Whether to draw the signed-in chrome around the outlet.
   *
   * hasStoredSession rather than `auth.loggedIn`, which is an EventEmitter and
   * has not fired yet on a first paint -- the login page would flash the
   * signed-in gutters and then lose them. See util/session.util.ts; the nav
   * headers use the same predicate to decide whether to call guarded
   * endpoints, so chrome and requests agree about who is looking.
   */
  get hasSession(): boolean {
    return hasStoredSession(this.sharedService.getAccessToken());
  }

  ngOnInit() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) { route = route.firstChild; }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
    )
      .subscribe((event) => {
        this.triggerPageAnimation();
        event.data.subscribe(routeData => {
          this.isControlModule = routeData.app !== undefined && routeData.app === 'cm';
          this.isFullWidth = !!routeData.fullWidth;
          this.auth.isUserActive.subscribe(valUser => {
            this.activeUser = valUser;
            if (!this.activeUser && this.isLoggedIn) {
              this.userService.getCurrentUser().subscribe(user => {
                if (user !== null) {
                  this.username = user.username;
                }
              });
            }
          });
          this.auth.loggedIn.subscribe(val => {
            this.isLoggedIn = val;
          });
        });
      });
  }

  private triggerPageAnimation() {
    if (!this.mainContent) return;
    const el: HTMLElement = this.mainContent.nativeElement;
    el.classList.remove('page-enter');
    void el.offsetWidth;
    el.classList.add('page-enter');
    setTimeout(() => el.classList.remove('page-enter'), 250);
  }

  logout() {
    this.username = '';
    this.auth.logout().subscribe(res => {
      this.router.navigate(['login']);
      this.auth.setLoginStatus(false);
    });
  }

  ngAfterViewInit() {}
}
